import { FC } from "react";

import { type StatusIconProps, initializeStatusIconProps } from "mds/utils/images";

export const PersonStatusIcon: FC<StatusIconProps> = (props) => {
  const { statusClassName, ...svgProps } = initializeStatusIconProps(props);
  return (
    <svg {...svgProps}>
      <path
        d="M0.833334 14V12.667C0.833334 11.8271 1.1672 11.0216 1.76107 10.4277C2.35493 9.83387 3.16047 9.5 4.00033 9.5H6.66634C6.94248 9.5 7.16634 9.72386 7.16634 10C7.16634 10.2761 6.94248 10.5 6.66634 10.5H4.00033C3.42569 10.5 2.87443 10.7284 2.4681 11.1348C2.06177 11.5411 1.83333 12.0924 1.83333 12.667V14C1.83333 14.2761 1.60948 14.5 1.33333 14.5C1.05719 14.5 0.833334 14.2761 0.833334 14Z"
        fill="currentColor"
      />
      <path
        d="M8.16634 4.66699C8.16634 3.47048 7.19679 2.50018 6.00033 2.5C4.80371 2.5 3.83333 3.47038 3.83333 4.66699C3.83351 5.86346 4.80382 6.83301 6.00033 6.83301C7.19669 6.83283 8.16617 5.86335 8.16634 4.66699ZM9.16634 4.66699C9.16617 6.41564 7.74897 7.83283 6.00033 7.83301C4.25153 7.83301 2.83351 6.41574 2.83333 4.66699C2.83333 2.91809 4.25142 1.5 6.00033 1.5C7.74908 1.50018 9.16634 2.9182 9.16634 4.66699Z"
        fill="currentColor"
      />
      <rect className={statusClassName} height="6" rx="3" width="6" x="9" y="9" />
    </svg>
  );
};
